import { environment } from '@environments/environment';

export const GET_ALL_STORE_OPPORTUNITIES_QUERY = (langcode: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_opportunities ?? '',
  body: {
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_language: langcode,
            },
          },
        ],
      },
    },
    from: 0,
    size: 10000,
  },
});
